module.exports = __webpack_public_path__ + "static/media/part.a7bf5eec.svg";